import { MiddlewareAction } from "../middleware";

export enum ReportsActions {
  REQUEST_GET_STATEMENTS = "REQUEST_GET_STATEMENTS",
  REQUEST_GET_DOCUMENT_URLS = "REQUEST_GET_DOCUMENT_URLS",
}

export function getStatements(): MiddlewareAction {
  return {
    actionName: ReportsActions.REQUEST_GET_STATEMENTS,
    type: "GET",
    url: "/employer-admin/statements",
  };
}

export function getDocumentUrl(statementId: string): MiddlewareAction {
  return {
    actionName: ReportsActions.REQUEST_GET_DOCUMENT_URLS,
    type: "GET",
    url: `/employer-admin/statements/document-urls?statementId=${statementId}`,
  };
}
